export const GRIPSIZE_LOADING = 'GRIPSIZE_LOADING';
export const GET_GRIPSIZE = 'GET_GRIPSIZE';

export const INIT_STATE = {
	isLoading: false,
    gripsize: {}
}


// WEBPACK FOOTER //
// ./src/gripsize/constants/index.js